import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export { gcd } from '@repo/utils';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
